import Swiper, { Keyboard, Navigation, Pagination } from 'swiper';
// import Swiper styles
import 'swiper/css';

// 
const sliders = document.querySelectorAll('[js-slider]')

if (sliders.length > 0) {
 for(const slider of sliders) {
   const nextBtn = slider.querySelector('[js-slider-next]')
   const prevBtn = slider.querySelector('[js-slider-prev]')

   const swiper = new Swiper(slider, {
     spaceBetween: window.innerWidth <= 768 ? 24 : 56,
     slidesPerView: 'auto',
     loop: slider.dataset.loop,
     slideToClickedSlide: false,
     mousewheel: {
       enabled: true,
       sensitivity: 5.5,
     },
     freeMode: {
       enabled: slider.dataset.freeMode,
       sticky: false,
       momentumBounce: false,

     },
     modules: [Navigation, Pagination],
     pagination: {
       el: '.swiper-pagination',
       type: 'custom',
       renderCustom: function (swiper, current, total) {
        return `<span>${current <= 9 ? 0 : ''}${current}</span>/<span>${total <= 9 ? 0 : ''}${total}</span>`
       }
     },
     navigation: {
       nextEl: nextBtn,
       prevEl: prevBtn,
     },
   })
 } 
}